module.exports = __webpack_public_path__ + "static/media/archive.30104c3f.svg";